import { render, staticRenderFns } from "./PetAndProjectThanksTabComponent.vue?vue&type=template&id=2a0c2ba6&scoped=true&"
import script from "./PetAndProjectThanksTabComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectThanksTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectThanksTabComponent.vue?vue&type=style&index=0&id=2a0c2ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0c2ba6",
  null
  
)

export default component.exports